import React from "react"
import SvgIcon from "./SvgIcon"

const ImageAltIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <path d="M7 2.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m4.225 4.053a.5.5 0 0 0-.577.093l-3.71 4.71-2.66-2.772a.5.5 0 0 0-.63.062L.002 13v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4.5z" />
    </SvgIcon>
  )
}

export default ImageAltIcon
